export const SAMPLE_YEAR = {
  "values": {
  "production": {
    "label": "production",
    "deviceTimeValues": {
      "0518d382-c229-4b95-a6b6-34390d8f2767": [
        {
          "read": "2025-03-01T00:00:00.000Z",
          "value": 1.1187610440662766
        },
        {
          "read": "2025-04-01T00:00:00.000Z",
          "value": 1.80850893535664
        },
        {
          "read": "2025-05-01T00:00:00.000Z",
          "value": 1.9750119453141604
        },
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": 2.416323959873088
        }
      ],
      "6667f0e5-aabc-4e0b-8d63-c7cf72ea58ac": [
        {
          "read": "2025-03-01T00:00:00.000Z",
          "value": 0.9679259428443154
        },
        {
          "read": "2025-04-01T00:00:00.000Z",
          "value": 1.5683127042959572
        },
        {
          "read": "2025-05-01T00:00:00.000Z",
          "value": 1.8191197241766556
        },
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": 2.2546403510187715
        }
      ]
    },
    "deviceNames": {
      "0518d382-c229-4b95-a6b6-34390d8f2767": "Solar-Ost",
      "6667f0e5-aabc-4e0b-8d63-c7cf72ea58ac": "Solar-West"
    },
    "timeBucket": "1 month"
  },
  "consumption": {
    "label": "consumption",
    "deviceTimeValues": {
      "4581f36f-9661-470f-b1ba-c358992a4712": [
        {
          "read": "2025-03-01T00:00:00.000Z",
          "value": 2.458979772443488
        },
        {
          "read": "2025-04-01T00:00:00.000Z",
          "value": 1.323213574834325
        },
        {
          "read": "2025-05-01T00:00:00.000Z",
          "value": 1.1195685873309826
        },
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": 1.5010111997725596
        }
      ]
    },
    "deviceNames": {
      "4581f36f-9661-470f-b1ba-c358992a4712": "Allgemein"
    },
    "timeBucket": "1 month"
  },
  "batteryCharge": {
    "label": "battery",
    "deviceTimeValues": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": [
        {
          "read": "2025-03-01T00:00:00.000Z",
          "value": 0.04639390283253132
        },
        {
          "read": "2025-04-01T00:00:00.000Z",
          "value": 0.07191543319019955
        },
        {
          "read": "2025-05-01T00:00:00.000Z",
          "value": 0.0810227870354785
        },
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": 0.08775425477286483
        }
      ]
    },
    "deviceNames": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": "2Kanter-Batterie"
    },
    "timeBucket": "1 month"
  },
  "batteryPower": { } ,
  "batteryPowerPositive": {
    "label": "battery",
    "deviceTimeValues": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": [
        {
          "read": "2025-02-28T23:00:00.000Z",
          "value": 326.5
        },
        {
          "read": "2025-03-31T22:00:00.000Z",
          "value": 573.5
        },
        {
          "read": "2025-04-30T22:00:00.000Z",
          "value": 543.7
        },
        {
          "read": "2025-05-31T22:00:00.000Z",
          "value": 298.8
        }
      ]
    },
    "deviceNames": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": "2Kanter-Batterie"
    },
    "timeBucket": "1 month"
  },
  "batteryPowerNegative": {
    "label": "battery",
    "deviceTimeValues": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": [
        {
          "read": "2025-02-28T23:00:00.000Z",
          "value": 314.2
        },
        {
          "read": "2025-03-31T22:00:00.000Z",
          "value": 546.3
        },
        {
          "read": "2025-04-30T22:00:00.000Z",
          "value": 511.4
        },
        {
          "read": "2025-05-31T22:00:00.000Z",
          "value": 285.9
        }
      ]
    },
    "deviceNames": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": "2Kanter-Batterie"
    },
    "timeBucket": "1 month"
  },
  "grid": {
    "label": "grid",
    "deviceTimeValues": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": [
        {
          "read": "2025-03-01T00:00:00.000Z",
          "value": 0.41592003254815586
        },
        {
          "read": "2025-04-01T00:00:00.000Z",
          "value": -2.030607352283988
        },
        {
          "read": "2025-05-01T00:00:00.000Z",
          "value": -2.6330896669097983
        },
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": -3.1458191171346307
        }
      ]
    },
    "deviceNames": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": "Hausanschluss"
    },
    "timeBucket": "1 month"
  },
  "gridPositive": {
    "label": "grid",
    "deviceTimeValues": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": [
        {
          "read": "2025-03-01T00:00:00.000Z",
          "value": 1.79298932182211
        },
        {
          "read": "2025-04-01T00:00:00.000Z",
          "value": 1.12077978707339
        },
        {
          "read": "2025-05-01T00:00:00.000Z",
          "value": 0.499380528941491
        },
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": 0.551601819543653
        }
      ]
    },
    "deviceNames": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": "Hausanschluss"
    },
    "timeBucket": "1 month"
  },
  "gridNegative": {
    "label": "grid",
    "deviceTimeValues": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": [
        {
          "read": "2025-03-01T00:00:00.000Z",
          "value": 1.79298932182211
        },
        {
          "read": "2025-04-01T00:00:00.000Z",
          "value": 1.12077978707339
        },
        {
          "read": "2025-05-01T00:00:00.000Z",
          "value": 0.499380528941491
        },
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": 0.551601819543653
        }
      ]
    },
    "deviceNames": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": "Hausanschluss"
    },
    "timeBucket": "1 month"
  }
  }
}
